import Call from '../Call';

const PushapiPartners = {
    get() {
        return Call(`pushapiPartner`);
    },

    save(feed) {
        return Call('pushapiPartner','POST', feed);
    },

    remove(id) {
        return Call(`pushapiPartner/${id}`,'DELETE');
    }
};

export default PushapiPartners;


// WEBPACK FOOTER //
// ./src/services/API/components/PushapiPartners.js